import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Männlich", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Weiblich", -1)
const _hoisted_3 = ["value"]

import { FormKitNode } from "@formkit/core";
import { ref, computed } from "vue";
import { usePublicStore } from "@/store/publicStore";
import { useSessionStore } from "@/store/sessionStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileForm',
  props: {
    profileModel: {},
    onSaveProfile: { type: Function },
    selectCpg: { type: Boolean },
    isEditing: { type: Boolean }
  },
  setup(__props: any) {

const publicStore = usePublicStore();
const sessionStore = useSessionStore();

const careProviderGroups = computed(() => {
  return publicStore.oppositeGroups;
});

const selectedCareProviderGroup = computed(
  () => sessionStore.selectedCareProviderGroup
);

function helpText() {
  return selectedCareProviderGroup.value?.is_orderer
    ? "Welche Apotheke liefert Medikamente für diesen Patienten?"
    : "Welches Heim bestellt Medikamente für diesen Patienten?";
}

const props = __props;

const profileModel = ref<any>(props.profileModel);

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    type: "form",
    modelValue: profileModel.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profileModel).value = $event)),
    onSubmit: _ctx.onSaveProfile,
    class: "mt-5",
    "submit-label": "Patientendaten speichern"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_FormKit, {
        type: "text",
        name: "firstName",
        label: "Vorname",
        validation: "required"
      }),
      _createVNode(_component_FormKit, {
        type: "text",
        name: "lastName",
        label: "Nachname",
        validation: "required"
      }),
      _createVNode(_component_FormKit, {
        type: "date",
        name: "birthday",
        label: "Geburtsdatum",
        validation: "required"
      }),
      _createVNode(_component_FormKit, {
        type: "select",
        name: "sex",
        label: "Geschlecht",
        validation: "required"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_FormKit, {
        type: "text",
        name: "veka",
        label: "VeKa-Nr.",
        validation: "length:20,20|number"
      }),
      (_ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_FormKit, {
            key: 0,
            type: "checkbox",
            label: "Verstorben",
            name: "deceased",
            validation: "boolean"
          }))
        : _createCommentVNode("", true),
      (_ctx.selectCpg)
        ? (_openBlock(), _createBlock(_component_FormKit, {
            key: 1,
            type: "select",
            name: "cpg",
            label: "Zugehörig",
            validation: "required",
            help: helpText()
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(careProviderGroups.value, (cpg) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cpg.id,
                  value: cpg.id
                }, _toDisplayString(cpg.group_name), 9, _hoisted_3))
              }), 128))
            ]),
            _: 1
          }, 8, ["help"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "onSubmit"]))
}
}

})